class Signup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            test: "testString",
            step: 3,
            submitting: false,
            introText: $('#at-checkbox-txt').text(),
            checkboxText: $('#at-checkbox-txt').text(),
            submitFirstName: "",
            submitLastName: "",
            submitEmail: "",
            submitBirthDate: "",
            submitBirthDay:"",
            submitBirthMonth:"",
            submitBirthYear:"",
            submitPostCode: "",
            submitNewsletter: false,
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            utm_term: '',
            utm_content: '',
            unique_id: this.generateUniqueID(),
            monthsDays: {
                '01': 31,
                '02': 29,
                '03': 31,
                '04': 30,
                '05': 31,
                '06': 30,
                '07': 31,
                '08': 31,
                '09': 30,
                '10': 31,
                '11': 30,
                '12': 31
            },
            selectedMonth: '01',
        };

        const self = this;

        this.handleChange = this.handleChange.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

        /*
        $(function() {
            $( "#at-datepicker" ).datepicker({
                yearRange: "1920:2019",
                changeYear: true,
                defaultDate: "1990-01-01",
                dateFormat: "yy-mm-dd",
                onSelect: function() {
                    var date = $(this).datepicker('getDate');
                    self.setState({ submitBirthDate: $.datepicker.formatDate("yy-mm-dd", date)});
                    console.log(self.state.submitBirthDate);
                }
            });
            $('#at-calendar-img').click(function(){
                $('#at-datepicker').datepicker('show');
              });
        });
        */
    }

    componentDidMount(){
        console.log('Newsletter Signup Ready!');
        const params = this.getUTMParams();
        this.setState(params);
    }

    componentDidUpdate(){
        console.log('First one!');

        const self = this;
    }

    handleChange(e){
        console.log('First two!', e.target.name, e.target.value);
        if(e.target.matches('#at-birth-day') && (e.target.value>31))
                e.target.value=31;
        if(e.target.matches('#at-birth-month') && (e.target.value>12))
                e.target.value=12;
        var todayYear = (new Date()).getFullYear();
        if(e.target.matches('#at-birth-year') && (e.target.value>todayYear))
                e.target.value=todayYear;

        this.setState({ [e.target.name] : e.target.value});
        this.forceUpdate();
 
        if(e.target.matches('#at-birth-day') || e.target.matches('#at-birth-month') || e.target.matches('#at-birth-year'))
        {
            var day = document.getElementById('at-birth-day').value;
            var month = document.getElementById('at-birth-month').value;
            var year = document.getElementById('at-birth-year').value;
            console.log('ccdev 72', day, month, year);  
            
            var d="";
            var thirty=[4,6,9,11];
            if((day!="") && (month!="") && (year!="") && year>1900) {
                if((day>=1) && (day<=31) && (month>0) && (month<=12) && ((month!=2) || (day<29)) && (!thirty.includes(month) || (day<=30) ))
                {   d = ("00"+year).substr(-4)+"-"+("00"+month).substr(-2)+"-"+("00"+day).substr(-2);    
                }
            }
            console.log('d00', d);
            this.setState({ submitBirthDate: d});
            this.forceUpdate();
        }

    }

    handleMonthChange(e){
        this.setState({selectedMonth: e.target.value});
        this.handleChange(e);
    }

    // validateRecaptcha() {
    // var response = grecaptcha.getResponse();
    // if (response.length === 0) {
    //     alert("You need to fill the captcha");
    //     return false;
    // } else {
    //     alert("validated");
    //     return true;
    // }
    // }

    handleCheckboxChange(event) {
        const target = event.target;
        const value = target.name === target.name ? target.checked : target.value;
        const name = target.name;

        this.setState({[name]: value });

        this.forceUpdate();
    }

    handleSubmit(event) {
        return submitUserForm();
        if (submitUserForm() === true) {
            event.preventDefault();
        }

    }

    // FETCH REQUESTS // FETCH REQUESTS // FETCH REQUESTS

    getToken(){
        const self = this;
        const { submitFirstName, submitLastName, submitEmail, submitBirthDate, utm_source, utm_medium, utm_campaign, utm_term, utm_content, unique_id } = self.state;

        if (wasAtreemoOptions && wasAtreemoOptions.hasOwnProperty('fbqNewLead')) {
            wasAtreemoOptions.fbqNewLead();
        }

        if (typeof apm != 'undefined' && typeof apm == 'object') {
            apm.setUserContext({
                id: unique_id,
                firstName: submitFirstName,
                lastName: submitLastName,
                dateOfBirth: submitBirthDate,
                email: submitEmail
            });
        }

        // var response = grecaptcha.getResponse();

        // if(response.length == 0){
        //     document.getElementById('g-recaptcha-error').innerHTML = '<span style="color:red;">This field is required.</span>';
        //     return false;
        // }

        document.getElementById('errors').innerHTML = "";

        var url = wasAtreemoOptions.siteDomain+'/wp-json/atreemo/1?reservation=false';

        if(this.state.submitSalutation !== ""){ url = url + "&submit_salutation=" + this.state.submitSalutation; }
        if(this.state.submitNumber !== ""){ url = url + "&submit_number=" + this.state.submitNumber; }
        if(this.state.submitFirstName !== ""){ url = url + "&submit_fname=" + this.state.submitFirstName; }
        if(this.state.submitLastName !== ""){ url = url + "&submit_lname=" + this.state.submitLastName; }
        if(this.state.submitEmail !== ""){ url = url + "&submit_email=" + this.state.submitEmail; }
        if(this.state.submitBirthDate !== ""){ url = url + "&submit_dob=" + this.state.submitBirthDate; }
        if(this.state.submitPostCode !== ""){ url = url + "&submit_postcode=" + this.state.submitPostCode; }
        if(this.state.submitNewsletter !== ""){ url = url + "&submit_newsletter=" + this.state.submitNewsletter; }
        if(this.state.utm_source !== ""){ url = url + "&utm_source=" + this.state.utm_source; }
        if(this.state.utm_medium !== ""){ url = url + "&utm_medium=" + this.state.utm_medium; }
        if(this.state.utm_campaign !== ""){ url = url + "&utm_campaign=" + this.state.utm_campaign; }
        if(this.state.utm_term !== ""){ url = url + "&utm_term=" + this.state.utm_term; }
        if(this.state.utm_content !== ""){ url = url + "&utm_content=" + this.state.utm_content; }
        if(this.state.unique_id !== ""){ url = url + "&unique_id=" + this.state.unique_id; }

        self.setState({
            submitting: true
        });

        fetch(url, {
            method: 'GET',
        }).then(
            function(response) {
                console.log(response);
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                    response.status);
                    return;
                }
                response.json().then(function(data) {
                    self.setState({
                        submitting: false
                    });
                    if(data.errors){
                        console.log('we got here');
                        for (let index = 0; index < data.errors.length; index++) {
                            if (typeof data.errors[index] === 'string' || data.errors[index] instanceof String){
                                document.getElementById('errors').innerHTML += '<div class="form-error"><p>'+data.errors[index]+'</p></div>';
                            }
                        }
                        var targetDiv = document.getElementById('was-atreemo');
                        targetDiv.scrollIntoView();
                    } else {
                        // gtag("event", "sign_up", {
                        //     method: "Website"
                        // });
                        // wasAtreemoOptions.fbqNewSignUp();
                        // if (typeof apm != 'undefined' && typeof apm == 'object') {
                        //     apm.setUserContext({
                        //         id: unique_id,
                        //         firstName: submitFirstName,
                        //         lastName: submitLastName,
                        //         dateOfBirth: submitBirthDate,
                        //         email: submitEmail
                        //     });

                        //     apm.addLabels({
                        //         utm_source: utm_source,
                        //         utm_medium: utm_medium,
                        //         utm_campaign: utm_campaign,
                        //         utm_term: utm_term,
                        //         utm_content: utm_content,
                        //         unique_id: unique_id
                        //     });
                        // }
                        var urlParams = '';
                        if (utm_source || utm_medium || utm_campaign || utm_term || utm_content) {
                            urlParams = '?utm_source=' + utm_source + '&utm_medium=' + utm_medium + '&utm_campaign=' + utm_campaign + '&utm_term=' + utm_term + '&utm_content=' + utm_content + '&unique_id=' + unique_id;
                        }

                        window.location.replace('/sign-up-thank-you' + urlParams);
                        // self.setState({
                        //     step: 4
                        // });
                        // return <Redirect to='/sign-up/?success=true'  />
                    }
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error', err);
        });
    }

    getUTMParams() {
        const urlParams = new URLSearchParams(window.location.search);
        return {
            utm_source: urlParams.get('utm_source') || '',
            utm_medium: urlParams.get('utm_medium') || '',
            utm_campaign: urlParams.get('utm_campaign') || '',
            utm_term: urlParams.get('utm_term') || '',
            utm_content: urlParams.get('utm_content') || '',
            unique_id: this.generateUniqueID(),
        };
    }

    generateUniqueID() {
        return 'xxxx-xxxx-xxxx-xxxx'.replace(/[x]/g, () =>
            (Math.random() * 16 | 0).toString(16)
        );
    }

    renderStepOne(){
        const { utm_source, utm_medium, utm_campaign, utm_term, utm_content, unique_id } = this.state;

        const dayOptions = [];
        for (let i = 1; i <= this.state.monthsDays[this.state.selectedMonth]; i++) {
            dayOptions.push(<option value={i} key={i}>{i}</option>);
        }

        const currentYear = new Date().getFullYear();
        const yearLimit = currentYear - 18;
        const limitYear = yearLimit - 1900;
        const yearOptions = [];
        for (let x = 0; x < limitYear; x++) {
            yearOptions.push(<option value={yearLimit - x} key={x}>{yearLimit - x}</option>);
        }

        return (
            <form className="step-3" onSubmit={this.getToken}>
                <p>{wasAtreemoOptions.introText}</p>
                <div id="errors"></div>
                <input type="hidden" name="utm_source" value={utm_source} readOnly />
                <input type="hidden" name="utm_medium" value={utm_medium} readOnly />
                <input type="hidden" name="utm_campaign" value={utm_campaign} readOnly />
                <input type="hidden" name="utm_term" value={utm_term} readOnly />
                <input type="hidden" name="utm_content" value={utm_content} readOnly />
                <input type="hidden" name="unique_id" value={unique_id} readOnly />
                <div className="input-wrapper input-wrapper-first-name">
                    <label>First Name *</label>
                    <input type="text" name="submitFirstName" required={true} onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper input-wrapper-last-name">
                    <label>Last Name *</label>
                    <input type="text" name="submitLastName" required={true} onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper input-wrapper-email">
                    <label>Email Address *</label>
                    <input type="text" name="submitEmail" required={true} onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper input-wrapper-postcode">
                    <label>Postcode *</label>
                    <input type="text" name="submitPostCode" onChange={this.handleChange}/>
                </div>
                <div className="input-wrapper input-wrapper-dob">
                    <label>Date of birth DD/MM/YYYY *</label>
                    <div className="row">
                        <div className="col-xs-4 col-sm-4 col-md-4 col-4">
                            <select id="at-birth-day" placeholder="DD" className="mb-3" required={true} onChange={this.handleChange}>
                                <option value="" selected disabled>DD</option>
                                { dayOptions }
                            </select>
                        </div>
                        <div className="col-xs-4 col-sm-4 col-md-4 col-4">
                             <select id="at-birth-month" placeholder="MM" className="mb-3" required={true} onChange={this.handleMonthChange}>
                                <option value="" selected disabled>MM</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select>
                        </div>
                        <div className="col-xs-4 col-sm-4 col-md-4 col-4">
                            <select id="at-birth-year" placeholder="YYYY" className="mb-3" required={true} onChange={this.handleChange}>
                                <option value="" selected disabled>YYYY</option>
                                { yearOptions }
                            </select>
                        </div>
                        <input type="hidden" id="at-datepicker" />
                    </div>
                </div>
    
                {/* <div class="g-recaptcha" data-sitekey="6LfbTrUiAAAAABf__6kvRlUz20lFiXud7BKMGh6Z" data-callback="enableBtn"></div>
                <div id="g-recaptcha-error"></div> */}
                <div className="input-wrapper input-wrapper-checkbox">
                    <label>
                        <input name="submitNewsletter" type="checkbox" checked={this.state.submitNewsletter} onChange={this.handleCheckboxChange} />
                        <span>{this.state.checkboxText} <a href="https://makinglifepeachy.com/privacy-policy/" target="_blank"> here</a>.</span>
                    </label>
                </div>
                <div className="input-wrapper">
                    <input type="submit" id="submit_details" value="Yes, sign me up" className="g-recaptcha" data-sitekey="6LfbTrUiAAAAABf__6kvRlUz20lFiXud7BKMGh6Z" onClick={this.getToken.bind(this)}/>
                    {this.state.submitting && <span className="loader-wrapper"><div className="loader"></div></span>}
                </div>
            </form>

        );
    }

    // renderStepTwo(){
    //     window.location.replace('/sign-up-thank-you' + urlParams);
    //     return (
    //         <div id="success" className="step-4">
    //             <h4>{ (wasAtreemoOptions.successTitle) ? wasAtreemoOptions.successTitle : 'Thanks for signing up!' }</h4>
    //             <p>{wasAtreemoOptions.successText}</p>
    //         </div>
    //     );
    // }

    render() {
        return (
            <div className="was-at-container">
                <div className="was-at-body">
                    <div className="gallery">
                        <div style={{backgroundImage: "url(" + document.getElementById('booking-image').textContent + ")"}}></div>
                    </div>
                    <div className="steps">
                        <div className="was-at-header">
                        <h2>{wasAtreemoOptions.heading}</h2>
                        </div>
                        {this.state.step == 3 ? ( this.renderStepOne() ) : null }
                        {/* {this.state.step == 4 ? ( this.renderStepTwo() ) : null } */}
                    </div>
                </div>
            </div>
        );
    }
}

if(document.getElementById("was-atreemo")){
    ReactDOM.render(<Signup />, document.getElementById("was-atreemo"));

    var recaptcha = document.createElement('script');
    recaptcha.src = 'https://www.google.com/recaptcha/api.js';
    recaptcha.async = true;
    recaptcha.defer = true;
    document.body.appendChild(recaptcha);

    var doc = document.documentElement || document.querySelector('html');

    doc.classList.add('was-atreemo-signup');
}

function onSignupSubmit(token) {
    document.getElementById("was-atreemo-signup-form").submit();
}

// document.getElementById("was-atreemo").addEventListener("submit",function(evt)
//   {

//   var response = grecaptcha.getResponse();
//   if(response.length == 0)
//   {
//     //reCaptcha not verified
//     alert("please verify you are human!");
//     evt.preventDefault();
//     return false;
//   }
  //captcha verified
  //do the rest of your validations here

// });
